/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback } from 'react';
import {
  Clock,
  Users,
  Briefcase,
  Filter,
  RefreshCw,
  Moon,
  FileText,
  DollarSign,
  X
} from 'lucide-react';

import TablasCompactas from '../../components/timesheets/TablasCompactas';
import GraficasPieTimesheets from '../../components/timesheets/GraficasPieTimesheets';
import HorasPorEquipo from '../../components/timesheets/HorasPorEquipo';
import HorasPorEstatus from '../../components/timesheets/HorasPorEstatus';
import HorasPorAprobadorEstatus from '../../components/timesheets/HorasPorAprobadorEstatus';
import DetalleRegistrosHorasTable from '../../components/timesheets/DetalleRegistrosHorasTable';

import {
  fetchTimesheetsFiltros,
  // fetchTimesheetsStats,
  // fetchTimesheetsTipoRegistro,
  // fetchTimesheetsHorasProyecto,
  // fetchTimesheetsHorasTecnico,
  // fetchTimesheetsDetalle,
  // fetchTimesheetsProductividad,
  // fetchTimesheetsResumenEquipo,
  // fetchTimesheetsHorasPorDia
  fetchTimesheetsDashboard,
  fetchTimesheetsEstatusPorAprobador
} from '../../api';

export default function TimesheetsDashboard() {
  /* =========================
     Estados principales
  ========================= */
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(true);
  const [initialLoadComplete, setInitialLoadComplete] = useState(false);
  const [projectsLoading, setProjectsLoading] = useState(true);

  /* =========================
     Fecha actual
  ========================= */
  const currentDate = new Date();
  const currentMonth = currentDate
    .toLocaleString('en-US', { month: 'long' })
    .toLowerCase();
  const currentYear = currentDate.getFullYear().toString();
  const currentMonthYear = `${currentMonth} ${currentYear}`;

  /* =========================
     Filtros
  ========================= */
    const [selectedMeses, setSelectedMeses] = useState([]);
    const [selectedAnios, setSelectedAnios] = useState([]);
    const [selectedTecnicos, setSelectedTecnicos] = useState([]);
    const [selectedEquipos, setSelectedEquipos] = useState([]);
    const [selectedTiposRegistro, setSelectedTiposRegistro] = useState([]);
    const [selectedProyectos, setSelectedProyectos] = useState([]);

  /* =========================
     Datos
  ========================= */
  const [stats, setStats] = useState({
    total_horas: 0,
    total_proyectos: 0,
    total_tecnicos: 0,
    costo_promedio_hora: 0,
    monto_total: 0
  });

  const [tipoRegistroData, setTipoRegistroData] = useState([]);
  const [horasProyectoData, setHorasProyectoData] = useState([]);
  const [horasTecnicoData, setHorasTecnicoData] = useState([]);
  const [detalleData, setDetalleData] = useState([]);
  const [productividadData, setProductividadData] = useState([]);
  const [resumenEquipoData, setResumenEquipoData] = useState([]);
  const [horasPorDiaData, setHorasPorDiaData] = useState([]);
  const [estatusPorAprobadorData, setEstatusPorAprobadorData] = useState([]);

  /* =========================
     Filtros disponibles
  ========================= */
  const [filtrosDisponibles, setFiltrosDisponibles] = useState({
    meses: [],
    anios: [],
    tecnicos: [],
    equipos: [],
    tipos_registro: [],
    proyectos: []
  });

  /* =========================
     Filtros disponibles (filtrados dinámicamente)
  ========================= */
  const [filtrosDisponiblesFiltrados, setFiltrosDisponiblesFiltrados] = useState({
    meses: [],
    anios: [],
    tecnicos: [],
    equipos: [],
    tipos_registro: [],
    proyectos: []
  });

  /* =========================
     Utilidades
  ========================= */
  const ordenarMeses = (meses) => {
    const ordenMeses = {
      january: 1,
      february: 2,
      march: 3,
      april: 4,
      may: 5,
      june: 6,
      july: 7,
      august: 8,
      september: 9,
      october: 10,
      november: 11,
      december: 12
    };

    return meses.sort((a, b) => {
      const [mesA, anioA] = a.value.split(' ');
      const [mesB, anioB] = b.value.split(' ');

      if (anioA !== anioB) {
        return parseInt(anioB) - parseInt(anioA);
      }
      return ordenMeses[mesB] - ordenMeses[mesA];
    });
  };

  /* =========================
     Cargar filtros
  ========================= */
  const loadFiltros = useCallback(async () => {
    try {
      const data = await fetchTimesheetsFiltros();
      if (data.meses?.length) {
        data.meses = ordenarMeses(data.meses);

        const mesActualDisponible = data.meses.find((mes) => mes.value === currentMonthYear);
        const mesPorDefecto = mesActualDisponible?.value || data.meses[0]?.value || '';

        if (mesPorDefecto) {
          setSelectedMeses((prev) => (prev.length > 0 ? prev : [mesPorDefecto]));
        }
      }
      setFiltrosDisponibles(data);
    } catch (error) {
      console.error('❌ Error cargando filtros:', error);
    }
  }, [currentMonthYear]);

  /* =========================
     Cargar datos
  ========================= */
  const loadData = useCallback(async () => {
    setLoading(true);
    try {
      const filters = {
        mes: selectedMeses,
        anio: selectedAnios,
        tecnico: selectedTecnicos,
        equipo: selectedEquipos,
        tipo_registro: selectedTiposRegistro,
        proyecto: selectedProyectos
      };

      // const [
      //   statsData,
      //   tipoRegistro,
      //   horasProyecto,
      //   horasTecnico,
      //   detalleResult,
      //   productividad,
      //   resumenEquipo,
      //   horasPorDia
      // ] = await Promise.all([
      //   fetchTimesheetsStats(filters),
      //   fetchTimesheetsTipoRegistro(filters),
      //   fetchTimesheetsHorasProyecto({ ...filters, limit: 1000 }),
      //   fetchTimesheetsHorasTecnico({ ...filters, limit: 1000 }),
      //   fetchTimesheetsDetalle({ ...filters, limit: 50 }),
      //   fetchTimesheetsProductividad(filters),
      //   fetchTimesheetsResumenEquipo(filters),
      //   fetchTimesheetsHorasPorDia(filters)
      // ]);

      // setStats(statsData);
      // setTipoRegistroData(tipoRegistro);
      // setHorasProyectoData(horasProyecto);
      // setHorasTecnicoData(horasTecnico);
      // setDetalleData(detalleResult?.data || []);
      // setProductividadData(productividad);
      // setResumenEquipoData(resumenEquipo);
      // setHorasPorDiaData(horasPorDia);
      const [data, estatusAprobador] = await Promise.all([
        fetchTimesheetsDashboard(filters),
        fetchTimesheetsEstatusPorAprobador(filters)
      ]);
      const detalleRegistrosHoras = data.detalle_registros_horas || data.detalle || [];

      setStats(data.stats);
      setTipoRegistroData(data.tipo_registro);
      setHorasProyectoData(data.horas_proyecto);
      setHorasTecnicoData(data.horas_tecnico);
      setDetalleData(detalleRegistrosHoras);
      setProductividadData(data.productividad);
      setResumenEquipoData(data.resumen_equipo);
      setHorasPorDiaData(data.horas_por_dia);
      setEstatusPorAprobadorData(estatusAprobador);
    } catch (error) {
      console.error('❌ Error cargando datos:', error);
    } finally {
      setLoading(false);
    }
  }, [
    selectedMeses,
    selectedAnios,
    selectedTecnicos,
    selectedEquipos,
    selectedTiposRegistro,
    selectedProyectos
  ]);

  /* =========================
     Effects
  ========================= */
  useEffect(() => {
    loadFiltros();
  }, [loadFiltros]);

  useEffect(() => {
    if (!initialLoadComplete) return;

    let active = true;
    setProjectsLoading(true);
    const loadPeriodProjects = async () => {
      try {
        const data = await fetchTimesheetsFiltros({ mes: selectedMeses, anio: selectedAnios });
        if (!active) return;

        const proyectos = data.proyectos || [];
        setFiltrosDisponibles((previous) => ({ ...previous, proyectos }));
        setSelectedProyectos((previous) => {
          const valid = previous.filter((project) => proyectos.includes(project));
          return valid.length === previous.length ? previous : valid;
        });
      } catch (error) {
        console.error('Error cargando clientes del periodo:', error);
      } finally {
        if (active) setProjectsLoading(false);
      }
    };

    loadPeriodProjects();
    return () => { active = false; };
  }, [initialLoadComplete, selectedMeses, selectedAnios]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!initialLoadComplete && filtrosDisponibles.meses.length > 0) {
      setInitialLoadComplete(true);
    }

    if (initialLoadComplete) {
      loadData();
    }
  }, [
    initialLoadComplete,
    filtrosDisponibles.meses,
    selectedMeses,
    selectedAnios,
    selectedTecnicos,
    selectedEquipos,
    selectedTiposRegistro,
    selectedProyectos
  ]);


  /* =========================
     Acciones
  ========================= */
  const handleManualRefresh = async () => {
    setRefreshing(true);
    await loadData();
    setRefreshing(false);
  };

  const addSelection = (setter, value) => {
    if (!value) return;
    setter((prev) => (prev.includes(value) ? prev : [...prev, value]));
  };

  const removeSelection = (setter, value) => {
    setter((prev) => prev.filter((item) => item !== value));
  };

  const clearAllFilters = () => {
    setSelectedMeses([]);
    setSelectedAnios([]);
    setSelectedTecnicos([]);
    setSelectedEquipos([]);
    setSelectedTiposRegistro([]);
    setSelectedProyectos([]);
  };

  /* =========================
     Lógica de filtros dependientes
  ========================= */
  // Extraer técnicos, tipos_registro y proyectos basados en CUALQUIER filtro seleccionado
  useEffect(() => {
    let tecnicosDisponibles = filtrosDisponibles.tecnicos;
    let tiposRegistroDisponibles = filtrosDisponibles.tipos_registro;
    let proyectosDisponibles = filtrosDisponibles.proyectos;
    let equiposDisponibles = filtrosDisponibles.equipos;

    // Si hay CUALQUIER filtro seleccionado, filtrar opciones que aparecen en los datos cargados
    const hayFiltro = selectedEquipos.length > 0 || selectedTecnicos.length > 0 || selectedTiposRegistro.length > 0 || selectedProyectos.length > 0;
    
    if (hayFiltro) {
      const tecnicosEnDatos = new Set();
      const tiposEnDatos = new Set();
      const proyectosEnDatos = new Set();
      const equiposEnDatos = new Set();
      
      // Extraer de horasTecnicoData
      if (horasTecnicoData && horasTecnicoData.length > 0) {
        horasTecnicoData.forEach(item => {
          if (item && item.tecnico) {
            tecnicosEnDatos.add(item.tecnico);
          }
        });
      }

      // Extraer de tipoRegistroData
      if (tipoRegistroData && tipoRegistroData.length > 0) {
        tipoRegistroData.forEach(item => {
          if (item && item.tipo) {
            tiposEnDatos.add(item.tipo);
          }
        });
      }

      // Extraer de horasProyectoData
      if (horasProyectoData && horasProyectoData.length > 0) {
        horasProyectoData.forEach(item => {
          if (item && item.proyecto) {
            proyectosEnDatos.add(item.proyecto);
          }
        });
      }

      // Extraer de resumenEquipoData
      if (resumenEquipoData && resumenEquipoData.length > 0) {
        resumenEquipoData.forEach(item => {
          if (item && item.equipo) {
            equiposEnDatos.add(item.equipo);
          }
        });
      }

      // Filtrar opciones disponibles
      if (tecnicosEnDatos.size > 0) {
        tecnicosDisponibles = filtrosDisponibles.tecnicos.filter(t => tecnicosEnDatos.has(t));
      }
      
      if (tiposEnDatos.size > 0) {
        tiposRegistroDisponibles = filtrosDisponibles.tipos_registro.filter(tipo => tiposEnDatos.has(tipo));
      }
      
      if (proyectosEnDatos.size > 0) {
        proyectosDisponibles = filtrosDisponibles.proyectos.filter(p => proyectosEnDatos.has(p));
      }

      if (equiposEnDatos.size > 0) {
        equiposDisponibles = filtrosDisponibles.equipos.filter(eq => equiposEnDatos.has(eq));
      }
    }

    // Actualizar filtros disponibles filtrados
    setFiltrosDisponiblesFiltrados({
      meses: filtrosDisponibles.meses,
      anios: filtrosDisponibles.anios,
      tecnicos: tecnicosDisponibles,
      equipos: equiposDisponibles,
      tipos_registro: tiposRegistroDisponibles,
      proyectos: proyectosDisponibles
    });
  }, [selectedEquipos, selectedTecnicos, selectedTiposRegistro, selectedProyectos, horasTecnicoData, tipoRegistroData, horasProyectoData, resumenEquipoData, filtrosDisponibles]);

  /* =========================
     Handlers para clics interactivos (desde componentes)
  ========================= */
  const handleEquipoClick = (equipo) => {
    if (selectedEquipos.includes(equipo)) {
      removeSelection(setSelectedEquipos, equipo);
    } else {
      addSelection(setSelectedEquipos, equipo);
    }
  };

  const handleTecnicoClick = (tecnico) => {
    if (selectedTecnicos.includes(tecnico)) {
      removeSelection(setSelectedTecnicos, tecnico);
    } else {
      addSelection(setSelectedTecnicos, tecnico);
    }
  };

  const handleProyectoClick = (proyecto) => {
    if (selectedProyectos.includes(proyecto)) {
      removeSelection(setSelectedProyectos, proyecto);
    } else {
      addSelection(setSelectedProyectos, proyecto);
    }
  };

  const handleTipoRegistroClick = (tipoRegistro) => {
    if (selectedTiposRegistro.includes(tipoRegistro)) {
      removeSelection(setSelectedTiposRegistro, tipoRegistro);
    } else {
      addSelection(setSelectedTiposRegistro, tipoRegistro);
    }
  };

  /* =========================
     Estilos
  ========================= */
  const cardClasses = isDarkMode
    ? 'bg-[#00261A] backdrop-blur-md border border-[#00FF66]/25 rounded-xl p-6 shadow-lg hover:shadow-[0_0_28px_rgba(0,255,102,0.15)] hover:border-[#00FF66]/45 hover:-translate-y-[3px] [transition:all_.25s_ease]'
    : 'bg-white border border-emerald-200 rounded-xl p-6 shadow-lg hover:shadow-[0_4px_20px_rgba(0,200,80,0.12)] hover:border-emerald-400 transition-all duration-300';

  const textSecondary = isDarkMode ? 'text-[#a0c8b0]' : 'text-gray-600';

  const themeClasses = isDarkMode
    ? 'bg-[#001A12]'
    : 'bg-gradient-to-br from-emerald-50 via-green-50 to-teal-50';

  const selectClasses = isDarkMode
    ? 'w-full px-3 py-2 rounded-lg border bg-[#001f16] border-[#00FF66]/25 text-[#e0ffe8] hover:border-[#00FF66]/55 focus:outline-none focus:border-[#00FF66] focus:shadow-[0_0_8px_rgba(0,255,102,0.2)] [transition:all_.25s_ease]'
    : 'w-full px-3 py-2 rounded-lg border bg-white border-gray-300 text-gray-900 hover:border-emerald-400 focus:outline-none focus:border-emerald-500';

  const renderMultiFilter = ({ label, options, selectedValues, onAdd, onRemove, disabled = false, getOptionValue = (option) => option, getOptionLabel = (option) => option }) => {
    const normalizedOptions = Array.isArray(options) ? options : [];

    return (
      <div>
        <label className={`${textSecondary} text-xs mb-1 block`}>{label}</label>
        <select
          value=""
          aria-label={label}
          disabled={disabled}
          onChange={(e) => onAdd(e.target.value)}
          style={isDarkMode ? { colorScheme: 'dark' } : {}}
          className={selectClasses}
        >
          <option value="">Seleccionar...</option>
          {normalizedOptions.map((option) => {
            const optionValue = getOptionValue(option);
            const optionLabel = getOptionLabel(option);
            return (
              <option key={optionValue} value={optionValue}>
                {optionLabel}
              </option>
            );
          })}
        </select>

        <div className="flex flex-wrap gap-2 mt-2 min-h-[28px]">
          {selectedValues.length === 0 ? (
            <span className={`${textSecondary} text-xs`}>Sin selección</span>
          ) : (
            selectedValues.map((value) => (
              <span
                key={value}
                className={isDarkMode
                  ? 'inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs bg-[#00FF66]/12 text-[#bff5d0] border border-[#00FF66]/35'
                  : 'inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs bg-emerald-100 text-emerald-700 border border-emerald-300'
                }
              >
                {value}
                <button
                  type="button"
                  onClick={() => onRemove(value)}
                  className={isDarkMode ? 'text-[#8be5ac] hover:text-white' : 'text-emerald-700 hover:text-emerald-900'}
                  title="Eliminar"
                  aria-label={`Eliminar ${label}: ${value}`}
                >
                  <X className="w-3 h-3" />
                </button>
              </span>
            ))
          )}
        </div>
      </div>
    );
  };

  /* =========================
     Loader inicial
  ========================= */
  if (loading && !initialLoadComplete) {
    return (
      <div className={`min-h-screen ${themeClasses} flex items-center justify-center`}>
        <div className="flex items-center space-x-4">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#00FF66]" />
          <span className="text-xl font-semibold text-[#00FF66]">
            Cargando Timesheets...
          </span>
        </div>
      </div>
    );
  }

  /* =========================
     Render
  ========================= */
  return (
      <div className={`min-h-screen ${themeClasses} transition-all duration-300`}>
        {/* Header */}
        <div className={isDarkMode
          ? 'bg-[#071a0f]/90 backdrop-blur-md border-b border-[#00FF66]/20 shadow-[0_2px_20px_rgba(0,255,102,0.08)]'
          : 'bg-white border-b border-emerald-200 shadow-sm'
        }>
          <div className="flex justify-between items-center px-6 py-5">
            <div>
              <div className="flex items-center gap-3 mb-1">
                <div className={isDarkMode
                  ? 'w-1 h-8 rounded-full bg-gradient-to-b from-[#00FF66] to-[#00ffb3]'
                  : 'w-1 h-8 rounded-full bg-gradient-to-b from-emerald-500 to-teal-400'
                } />
                <h1 className={isDarkMode
                  ? 'text-3xl font-bold bg-gradient-to-r from-[#00FF66] via-[#00ffb3] to-[#00FF66] bg-clip-text text-transparent'
                  : 'text-3xl font-bold text-emerald-700'
                }>
                  Timesheets
                </h1>
              </div>
              <p className={`${textSecondary} text-sm ml-4`}>
                Gestión de Tiempo y Registros de Horas
              </p>
            </div>
            
            <div className="flex items-center space-x-3">
              <button
                onClick={handleManualRefresh}
                disabled={refreshing}
                className={`p-2 rounded-lg border transition-all ${
                  isDarkMode
                    ? 'bg-[#00FF66]/10 border-[#00FF66]/30 text-[#00FF66] hover:bg-[#00FF66]/20 hover:border-[#00FF66]/60'
                    : 'bg-emerald-50 border-emerald-300 text-emerald-700 hover:bg-emerald-100'
                } ${refreshing ? 'opacity-50 cursor-not-allowed' : ''}`}
                title="Actualizar datos"
              >
                <RefreshCw className={`w-5 h-5 ${refreshing ? 'animate-spin' : ''}`} />
              </button>
  
              <button
                onClick={() => setIsDarkMode(!isDarkMode)}
                className={`p-2 rounded-lg border transition-all ${
                  isDarkMode
                    ? 'bg-[#00FF66]/10 border-[#00FF66]/30 text-[#00FF66] hover:bg-[#00FF66]/20 hover:border-[#00FF66]/60'
                    : 'bg-emerald-50 border-emerald-300 text-emerald-700 hover:bg-emerald-100'
                }`}
                title={isDarkMode ? 'Modo claro' : 'Modo oscuro'}
              >
                <Moon className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>
  
        {/* Contenido principal */}
        <div className="px-6 py-8 space-y-8">
          {/* Filtros */}
          <div className={cardClasses}>
            <div className="flex items-center justify-between gap-3 mb-4">
              <div className="flex items-center gap-3">
              <Filter className="w-5 h-5 text-[#00FF66]" />
              <h2 className={isDarkMode ? 'text-[#00FF66] text-xl font-bold' : 'text-emerald-700 text-xl font-bold'}>Filtros</h2>
              </div>
              <button
                type="button"
                onClick={clearAllFilters}
                className={isDarkMode
                  ? 'px-3 py-1.5 rounded-lg border border-[#00FF66]/30 text-[#9fe8b9] hover:border-[#00FF66]/55 hover:text-white text-xs'
                  : 'px-3 py-1.5 rounded-lg border border-emerald-300 text-emerald-700 hover:border-emerald-500 text-xs'
                }
              >
                Limpiar filtros
              </button>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4">
              {renderMultiFilter({
                label: 'Mes',
                options: filtrosDisponibles.meses,
                selectedValues: selectedMeses,
                onAdd: (value) => addSelection(setSelectedMeses, value),
                onRemove: (value) => removeSelection(setSelectedMeses, value),
                getOptionValue: (option) => option.value,
                getOptionLabel: (option) => option.label
              })}

              {renderMultiFilter({
                label: 'Año',
                options: filtrosDisponibles.anios,
                selectedValues: selectedAnios,
                onAdd: (value) => addSelection(setSelectedAnios, value),
                onRemove: (value) => removeSelection(setSelectedAnios, value)
              })}

              {renderMultiFilter({
                label: 'Técnico',
                options: filtrosDisponiblesFiltrados.tecnicos,
                selectedValues: selectedTecnicos,
                onAdd: (value) => addSelection(setSelectedTecnicos, value),
                onRemove: (value) => removeSelection(setSelectedTecnicos, value)
              })}

              {renderMultiFilter({
                label: 'Equipo',
                options: filtrosDisponiblesFiltrados.equipos,
                selectedValues: selectedEquipos,
                onAdd: (value) => addSelection(setSelectedEquipos, value),
                onRemove: (value) => removeSelection(setSelectedEquipos, value)
              })}

              {renderMultiFilter({
                label: 'Tipo Registro',
                options: filtrosDisponiblesFiltrados.tipos_registro,
                selectedValues: selectedTiposRegistro,
                onAdd: (value) => addSelection(setSelectedTiposRegistro, value),
                onRemove: (value) => removeSelection(setSelectedTiposRegistro, value)
              })}

              {renderMultiFilter({
                label: 'Proyecto',
                options: projectsLoading ? [] : filtrosDisponiblesFiltrados.proyectos.filter(
                  (project) => filtrosDisponibles.proyectos.includes(project)
                ),
                disabled: projectsLoading,
                selectedValues: selectedProyectos,
                onAdd: (value) => addSelection(setSelectedProyectos, value),
                onRemove: (value) => removeSelection(setSelectedProyectos, value)
              })}
            </div>
          </div>
  
          {/* KPIs */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">

            {/* === VALOR GENERADO (hero card) === */}
            <div className={isDarkMode
              ? 'bg-[#00261A] backdrop-blur-md border border-[#00FF66]/25 border-l-4 border-l-[#00FF66] rounded-xl p-6 shadow-[0_0_10px_rgba(0,255,102,0.2),0_0_25px_rgba(0,255,102,0.08)] hover:shadow-[0_0_12px_rgba(0,255,102,0.28),0_0_32px_rgba(0,255,102,0.12)] hover:-translate-y-[3px] [transition:all_.25s_ease] relative overflow-hidden'
              : 'bg-white border-2 border-emerald-400 rounded-xl p-6 shadow-[0_0_20px_rgba(0,200,80,0.18)] hover:shadow-[0_0_32px_rgba(0,200,80,0.28)] transition-all duration-300'
            }>
              {isDarkMode && <div className="absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-[#00FF66] to-transparent" />}
              <div className="flex items-center justify-between mb-3">
                <p className={`${textSecondary} text-xs font-semibold uppercase tracking-widest`}>Valor Generado</p>
                <div className={isDarkMode
                  ? 'w-10 h-10 rounded-xl border border-[#00FF66]/35 bg-[#00FF66]/15 flex items-center justify-center'
                  : 'w-10 h-10 rounded-xl border border-emerald-300 bg-emerald-100 flex items-center justify-center'
                }>
                  <DollarSign className="w-5 h-5" style={{ color: '#00FF66' }} />
                </div>
              </div>
              <p className={isDarkMode ? 'text-[#00FF66] text-2xl font-bold leading-tight' : 'text-emerald-600 text-2xl font-bold leading-tight'}>
                {new Intl.NumberFormat('es-MX', {
                  style: 'currency',
                  currency: 'MXN',
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }).format(stats.monto_total ?? 0)}
              </p>
              <p className={isDarkMode ? 'text-[#a0c8b0] text-xs mt-2' : 'text-gray-400 text-xs mt-2'}>Impacto financiero</p>
            </div>

            {/* === TOTAL HORAS === */}
            <div className={cardClasses}>
              <div className="flex items-center justify-between mb-3">
                <p className={`${textSecondary} text-xs font-semibold uppercase tracking-widest`}>Total Horas</p>
                <div className={isDarkMode
                  ? 'w-10 h-10 rounded-xl border border-[#1EEB8A]/35 bg-[#1EEB8A]/15 flex items-center justify-center'
                  : 'w-10 h-10 rounded-xl border border-emerald-300 bg-emerald-100 flex items-center justify-center'
                }>
                  <Clock className="w-5 h-5" style={{ color: '#1EEB8A' }} />
                </div>
              </div>
              <p className={isDarkMode ? 'text-[#00FF66] text-3xl font-bold' : 'text-emerald-700 text-3xl font-bold'}>
                {stats.total_horas.toLocaleString('es-MX', {maximumFractionDigits: 2})}
              </p>
            </div>

            {/* === TOTAL CLIENTES === */}
            <div className={cardClasses}>
              <div className="flex items-center justify-between mb-3">
                <p className={`${textSecondary} text-xs font-semibold uppercase tracking-widest`}>Total Clientes</p>
                <div className={isDarkMode
                  ? 'w-10 h-10 rounded-xl border border-[#00D4AA]/35 bg-[#00D4AA]/15 flex items-center justify-center'
                  : 'w-10 h-10 rounded-xl border border-teal-300 bg-teal-100 flex items-center justify-center'
                }>
                  <Briefcase className="w-5 h-5" style={{ color: '#00D4AA' }} />
                </div>
              </div>
              <p className={isDarkMode ? 'text-[#00ffb3] text-3xl font-bold' : 'text-teal-700 text-3xl font-bold'}>
                {stats.total_proyectos}
              </p>
            </div>

            {/* === TOTAL TÉCNICOS === */}
            <div className={cardClasses}>
              <div className="flex items-center justify-between mb-3">
                <p className={`${textSecondary} text-xs font-semibold uppercase tracking-widest`}>Total Técnicos</p>
                <div className={isDarkMode
                  ? 'w-10 h-10 rounded-xl border border-[#00B8FF]/35 bg-[#00B8FF]/15 flex items-center justify-center'
                  : 'w-10 h-10 rounded-xl border border-sky-300 bg-sky-100 flex items-center justify-center'
                }>
                  <Users className="w-5 h-5" style={{ color: '#00B8FF' }} />
                </div>
              </div>
              <p className={isDarkMode ? 'text-[#00FF66] text-3xl font-bold' : 'text-emerald-700 text-3xl font-bold'}>
                {stats.total_tecnicos}
              </p>
            </div>

            {/* === COSTO PROM/HORA === */}
            <div className={cardClasses}>
              <div className="flex items-center justify-between mb-3">
                <p className={`${textSecondary} text-xs font-semibold uppercase tracking-widest`}>Costo Prom/Hora</p>
                <div className={isDarkMode
                  ? 'w-10 h-10 rounded-xl border border-[#A56EFF]/35 bg-[#A56EFF]/15 flex items-center justify-center'
                  : 'w-10 h-10 rounded-xl border border-violet-300 bg-violet-100 flex items-center justify-center'
                }>
                  <FileText className="w-5 h-5" style={{ color: '#A56EFF' }} />
                </div>
              </div>
              <p className={isDarkMode ? 'text-[#00ffb3] text-3xl font-bold' : 'text-teal-700 text-3xl font-bold'}>
                ${stats.costo_promedio_hora.toLocaleString('es-MX', {maximumFractionDigits: 2})}
              </p>
            </div>

          </div>
  
          {/* Tablas Compactas */}
          <TablasCompactas
            horasProyectoData={horasProyectoData}
            horasTecnicoData={horasTecnicoData}
            tipoRegistroData={tipoRegistroData}
            resumenEquipoData={resumenEquipoData}
            isDarkMode={isDarkMode}
            onProyectoClick={handleProyectoClick}
            onTecnicoClick={handleTecnicoClick}
            onTipoRegistroClick={handleTipoRegistroClick}
            onEquipoClick={handleEquipoClick}
            selectedProyectos={selectedProyectos}
            selectedTecnicos={selectedTecnicos}
            selectedTiposRegistro={selectedTiposRegistro}
            selectedEquipos={selectedEquipos}
          />
  
          {/* Graficas pie */}
          <GraficasPieTimesheets
            tipoRegistroData={tipoRegistroData}
            horasProyectoData={horasProyectoData}
            isDarkMode={isDarkMode}
            onProyectoClick={handleProyectoClick}
            onTipoRegistroClick={handleTipoRegistroClick}
            selectedProyectos={selectedProyectos}
            selectedTiposRegistro={selectedTiposRegistro}
          />
  
          {/* Horas por Equipo */}
          <HorasPorEquipo
            resumenEquipoData={resumenEquipoData}
            horasPorDiaData={horasPorDiaData}
            isDarkMode={isDarkMode}
            onEquipoClick={handleEquipoClick}
            selectedEquipos={selectedEquipos}
          />
  
          {/* Información adicional */}
          <div className={cardClasses}>
            <div className="flex items-center gap-3 mb-4">
              <div className={isDarkMode ? 'w-1 h-6 rounded-full bg-[#00FF66]' : 'w-1 h-6 rounded-full bg-emerald-500'} />
              <h3 className={isDarkMode ? 'text-[#00FF66] text-xl font-bold' : 'text-emerald-700 text-xl font-bold'}>
                Información Adicional
              </h3>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className={`p-4 rounded-lg border ${
                isDarkMode ? 'bg-[#00FF66]/5 border-[#00FF66]/15' : 'bg-emerald-50 border-emerald-200'
              }`}>
                <p className={textSecondary}>Registros detallados</p>
                <p className={isDarkMode ? 'text-[#00FF66] text-2xl font-bold mt-1' : 'text-emerald-700 text-2xl font-bold mt-1'}>{detalleData.length}</p>
              </div>
              <div className={`p-4 rounded-lg border ${
                isDarkMode ? 'bg-[#00FF66]/5 border-[#00FF66]/15' : 'bg-emerald-50 border-emerald-200'
              }`}>
                <p className={textSecondary}>Técnicos con productividad</p>
                <p className={isDarkMode ? 'text-[#00FF66] text-2xl font-bold mt-1' : 'text-emerald-700 text-2xl font-bold mt-1'}>{productividadData.length}</p>
              </div>
              <div className={`p-4 rounded-lg border ${
                isDarkMode ? 'bg-[#00FF66]/5 border-[#00FF66]/15' : 'bg-emerald-50 border-emerald-200'
              }`}>
                <p className={textSecondary}>Equipos</p>
                <p className={isDarkMode ? 'text-[#00FF66] text-2xl font-bold mt-1' : 'text-emerald-700 text-2xl font-bold mt-1'}>{resumenEquipoData.length}</p>
              </div>
            </div>
          </div>

          <HorasPorEstatus
            records={detalleData}
            isDarkMode={isDarkMode}
          />

          <HorasPorAprobadorEstatus
            rows={estatusPorAprobadorData}
            isDarkMode={isDarkMode}
          />

          {/* Detalle de registros de horas */}
          <DetalleRegistrosHorasTable
            records={detalleData}
            isDarkMode={isDarkMode}
          />
        </div>
      </div>
    );
  }
  